
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.094 1.49c0 .593-.36 1.105-.881 1.345a.244.244 0 00-.15.216v4.121c0 .183.154.331.344.331h3.972c.097 0 .182-.06.224-.144.152-.308.412-.557.732-.704a.244.244 0 00.15-.216V3.051a.244.244 0 00-.15-.216 1.487 1.487 0 01-.882-1.345C6.453.667 7.146 0 8 0s1.547.667 1.547 1.49c0 .593-.36 1.105-.882 1.345a.244.244 0 00-.15.216v3.388c0 .094.063.175.15.216.32.147.58.396.732.704a.253.253 0 00.224.144h3.972c.19 0 .344-.148.344-.33V3.05a.244.244 0 00-.15-.216 1.487 1.487 0 01-.881-1.345c0-.823.692-1.49 1.547-1.49C15.307 0 16 .667 16 1.49c0 .593-.36 1.105-.882 1.345a.244.244 0 00-.15.216v4.563c0 .487-.41.883-.916.883h-4.43a.253.253 0 00-.225.144 1.526 1.526 0 01-.732.704.244.244 0 00-.15.216v3.388c0 .094.063.176.15.216.522.24.882.752.882 1.345C9.547 15.333 8.854 16 8 16s-1.547-.667-1.547-1.49c0-.593.36-1.105.882-1.345a.244.244 0 00.15-.216V9.561a.244.244 0 00-.15-.216 1.526 1.526 0 01-.732-.704.253.253 0 00-.224-.144H2.407a.338.338 0 00-.344.33v4.122c0 .094.062.176.15.216.52.24.881.752.881 1.345 0 .823-.692 1.49-1.547 1.49C.693 16 0 15.333 0 14.51c0-.593.36-1.105.882-1.345a.244.244 0 00.15-.216V3.051a.244.244 0 00-.15-.216A1.487 1.487 0 010 1.49C0 .667.693 0 1.547 0c.855 0 1.547.667 1.547 1.49z","fill":"currentColor"}})])
          )
        }
      }
    